var map = {
	"./analysis.js": "gSk2",
	"./embranchment.js": "/2i0",
	"./finance.js": "VlA7",
	"./insurance.js": "6k0T",
	"./report.js": "Udpc"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "DTYf";


//////////////////
// WEBPACK FOOTER
// ./src/router/ultimate nonrecursive ^(?!\.\/index|\.\/cockpit).*\.js$
// module id = DTYf
// module chunks = 226